import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full border-t border-line bg-ink pb-24 pt-10 sm:pb-10" data-id="element-99" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-100" data-mp="3gg0xbxz0nnv0">
        <p className="font-display text-2xl font-extrabold uppercase tracking-[0.12em] text-fg" data-id="element-101" data-mp="32o48c2sn9u2u">
          Handball <span className="text-accent" data-id="element-102" data-mp="36oy05797jt10">360</span> Ready™
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-accent/50" aria-hidden="true" data-id="element-103" data-mp="36n3axgqwler4" />
        <p className="mt-6 text-sm leading-relaxed text-muted" data-id="element-104" data-mp="3uftpzyu3se5m">
          © 2026 HANDBALL 360 READY™ — All rights reserved.
        </p>
        <p className="mt-1 text-sm text-muted" data-id="element-105" data-mp="3lelzi2xtwhm3">
          Digital coaching system for handball coaches.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-xs leading-relaxed text-muted" data-id="element-106" data-mp="3qcnlavmn2v19">
          Results depend on how the system is applied in real training
          environments.
        </p>
      </div>
    </footer>;
}